import styled from 'styled-components';
import { media, mediaQuery } from '../../../common/styles/styleUtil';

export const Wrapper = styled.div`
  max-width: 1140px;
  margin: 0 auto;
  .mobile-card-ads {
    display: none;
    width: 100%;
    ${media.xs`
      display: flex;
    `};
  }
  .what-to-read {
    ${media.xs`
     padding: 0 17px;
   `};
  }
`;

export const TopContentWrapper = styled.div`
  width: 100%;
  padding: 32px 0;
  background-color: #f3f4f6;
`;

export const BottomContentWrapper = styled(TopContentWrapper)`
  padding-top: 40px;
  background-color: #ffffff;
`;

export const DisclaimerContainer = styled.div`
  margin: 17px auto 24px auto;
  max-width: 1140px;

  @media (${mediaQuery.tablet}) {
    padding: 0 24px;
  }

  @media (${mediaQuery.mobile}) {
    padding: 0 16px;
  }
`;

export const Divider = styled.hr`
  clear: both;
  width: 100%;
  margin: 0;
  height: 1px;
  background-color: #d2d6da;
  border: none;
  @media (${mediaQuery.tablet}) {
    width: auto;
    margin: 0 24px;
  }
  ${media.xs`
    margin: 0;
  `}
  &.recommended-divider {
    ${media.xs`
      margin: 0 16px;;
    `}
  }
`;
